<template lang="pug">
  v-dialog(v-model='dialogLoading', persistent max-width='400px' style='background:#f1f2f1')
    v-container(style='max-width: 400px;background:#f1f2f1')
      div(style="margin-top: 20px;")
        v-flex(xs12 sm12)
          v-layout(align-start='', justify-center='', row='', wrap fill-height='')
            v-flex(xs12)
              v-card-title(style="padding: 7px;").justify-center
                h4.black--text  Esperando Respuesta del Servidor.!!
            v-flex(xs12)
              div(style='display: flex;justify-content: center;').text-xs-center
                img(src='../assets/waiting.gif', with='200' ,height='150')
            v-flex(xs12)
              v-card-title(style="padding: 7px;").justify-center
                h5.black--text  Por favor espere...
</template>

<script>
export default {
  props: ['dialogLoading'],
  data: () => ({}),
  methods: {}
}
</script>
